export const dashboardService = {
    chargerCount: (data) => window.axios.post('get-charger-count', data),
    bookingCount: (data) => window.axios.post('get-booking-count', data),
    userCount: (data) => window.axios.post('get-user-count', data),
    dataCount: (data) => window.axios.post('get-data-count', data),
};